import React, {useCallback, useState, useEffect} from 'react';
import {EpicGamesNavigation} from '@wf-components/navigation-react';
import {useAccountStore} from 'epic-ue-shared';
import {getLocale} from '@epic-core/common';
import {generateRoutePath} from 'epic-ue-locale-mode';
import root from 'window-or-global';
import type {NavLinkClickEvent} from '@wf-components/navigation-consumer';
import {isNeverMode, setCookieLocaleHandler, useLocaleClickHandler} from 'epic-ue-locale-mode';
import {useLocation} from 'react-router-dom';
import {createGlobalStyle, css} from 'styled-components';

const NavScrollStyleCSS = css`
    html {
        scroll-padding-top: var(--eg-global-nav-height, 4.5rem);
    }
`;
const NavScrollStyle = createGlobalStyle`${NavScrollStyleCSS}`;

export const GlobalNavWrapper = (): JSX.Element => {
    const {account} = useAccountStore();
    const location = useLocation();
    const pathname = location.pathname;
    const locale = getLocale();

    const clientConfig = root.clientEnvConfig || {};
    const serverUrl = clientConfig.EPIC_SERVER_URL;

    const [accountState, setAccountState] = useState('');

    useEffect(() => {
        if (window.location.href) {
            try {
                const url = new URL(window.location.href);
                if (url) {
                    url.searchParams.set('state', pathname);
                    url.searchParams.set('lang', locale.replace(/-/, '_'));
                    setAccountState(url.searchParams.toString());
                }
            } catch (e) {
                console.log('Failed to parse href', e);
            }
        }
    }, [pathname, locale]);

    const navLinkOnClick = useCallback(
        (e: CustomEvent<NavLinkClickEvent>) => {
            const link = e.detail?.link;
            if (link && link?.owner === 'site' && link.relativePath) {
                e.detail.originalEvent.preventDefault();
                root.location.href = generateRoutePath(link.relativePath);
            }
        },
        [generateRoutePath]
    );

    const localeOnClick = useLocaleClickHandler();

    return (
        <>
            <EpicGamesNavigation
                domain={serverUrl}
                locale={locale}
                isLoggedIn={account.isLoggedIn}
                displayName={account.displayName}
                disableSearch={true}
                navLinkOnClick={navLinkOnClick}
                signInLinkHref={`/login${accountState ? `?${accountState}` : ''}`}
                signOutLinkHref={`/logout${accountState ? `?${accountState}` : ''}`}
                blackListLangCodes={['sv', 'uk', 'nl', 'cs', 'da', 'ro']}
                localeOnClick={localeOnClick}
            />
            <NavScrollStyle />
        </>
    );
};
